import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFound from '@/views/NotFound.vue'

/*** rgv imports ***/
// leads components
// import Leads from '@/views/Leads.vue'
// import Lead from '@/components/leads/Lead.vue'
import LeadForm from '@/components/leads/LeadForm.vue'


Vue.use(VueRouter)

const routes = [
  { name: 'NotFound', path: '/404', component: NotFound, meta: { layout: "auth" } },
// leads paths
  // { name: 'LeadList', path: '/leads(/page/)?:page?', component: Leads, props: true },
  { name: 'LeadCatcher', path: '/', component: LeadForm },
  // { name: 'LeadNew', path: '/leads/new', component: LeadForm },
  // { name: 'LeadShow', path: '/leads/:id', component: Lead, props: true },
  // { name: 'LeadEdit', path: '/leads/:id/edit', component: LeadForm, props: true },


  { path: '*', component: NotFound, meta: { layout: "auth" } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
